import { Tooltip } from "@material-ui/core";
import React, { useCallback } from "react";

import { Box } from "../../../../../dtos/box";
import { ButtonWithConfirm } from "../../../../ButtonWithConfirm";
import { BoxFeature } from "../types";

import { useDeleteLease } from "./useDeleteLease";

interface Props {
    box: Box;
    onLeaseDeleted: () => void;
    feature: BoxFeature;
}

export function LeaseDeleteButton({
    box,
    onLeaseDeleted,
    feature,
}: Props) {
    const { deleteLease, loading } = useDeleteLease(box.id);

    const handleConfirm = useCallback(() => {
        deleteLease(onLeaseDeleted);
    }, [deleteLease, onLeaseDeleted]);

    return (
        <Tooltip title={feature.reason}>
            <span>
                <ButtonWithConfirm
                    variant="contained"
                    color="secondary"
                    confirmDialogContent="Are you sure you want do delete this box's current lease?"
                    confirmedCallback={handleConfirm}
                    disabled={!feature.enabled || loading}
                >
                    {loading ? "Deleting" : "Delete Lease"}
                </ButtonWithConfirm>
            </span>
        </Tooltip>
    );
}
